import request from '@/utils/request'

// 查询质押融资列表
export function listZyrz(query) {
  return request({
    url: '/web/msb/zyOld/list',
    method: 'get',
    params: query
  })
}
